import React, { Component } from 'react'
import ContentLoader from 'react-content-loader'

export default class PageLoader extends Component {
  render() {
    return (
      <ContentLoader primaryOpacity={0.5} secondaryOpacity={0.5} height={280}>
        <rect x={2} y={2} rx="1" ry="1" width={65} height={13} />
        <rect x={340} y={2} rx="1" ry="1" width={40} height={13} />
        <rect x={300} y={2} rx="1" ry="1" width={30} height={13} />

        <rect x={2} y={25} rx="1" ry="1" width={50} height={10} />
        <rect x={2} y={40} rx="1" ry="1" width={50} height={10} />
        <rect x={2} y={55} rx="1" ry="1" width={50} height={10} />
        <rect x={2} y={70} rx="1" ry="1" width={50} height={10} />
        <rect x={2} y={85} rx="1" ry="1" width={50} height={10} />
        <rect x={2} y={100} rx="1" ry="1" width={50} height={10} />
        <rect x={2} y={115} rx="1" ry="1" width={50} height={10} />
        <rect x={2} y={130} rx="1" ry="1" width={50} height={10} />
        <rect x={2} y={145} rx="1" ry="1" width={50} height={10} />

      </ContentLoader>
    )
  }
}
